module.exports = __webpack_public_path__ + "static/3-a3079631cf8b5156be911172da6d49b4.png";